<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-cascades"></i> 系统分类/目录管理
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div class="handle-box">
                <el-input class="handle-input mr10" clearable placeholder="景区分类名称" v-model="search.keyword"></el-input>
                <el-button @click="handleSearch" icon="el-icon-search" type="primary">搜索</el-button>
                <el-button @click="getInMenuData" icon="el-icon-refresh" type="warning">刷新</el-button>
            </div>
            <el-table
                    :data="tableData"
                    border
                    class="table"
                    header-cell-class-name="table-header"
                    ref="multipleTable"
            >
                <el-table-column align="center" label="ID" prop="Id" sortable width="65"></el-table-column>
                <el-table-column align="center" label="分类名称" prop="Cname" sortable width="220"></el-table-column>
                <el-table-column align="center" label="分类拼音" prop="Chinese" sortable></el-table-column>
                <el-table-column align="center" label="分类类别" prop="Ctype" :filter-method="filterTag"
                                 :filters="[{ text: '机构规模', value: '0' }, { text: '业务范围', value: '1' },{ text: '业务类型', value: '2' }]">
                    <template slot-scope="scope">
                        <el-tag
                                :type="scope.row.Ctype===0?'danger':(scope.row.Ctype===1?'info':'success')"
                        >{{scope.row.Ctype===0?'机构规模':(scope.row.Ctype===1?'业务范围':(scope.row.Ctype===2?'业务类型':'客户等级'))}}
                        </el-tag>
                    </template>

                </el-table-column>
                <el-table-column align="center" label="分类备注" prop="Cmemo"></el-table-column>
                <el-table-column align="center" label="分类状态" prop="Cstate">
                    <template slot-scope="scope">
                        <el-tag
                                :type="scope.row.Cstate===0?'danger':'success'"
                        >{{scope.row.Cstate===0?'屏蔽中':'正显示'}}
                        </el-tag>
                    </template>
                </el-table-column>

                <el-table-column align="center" label="操作" width="180">
                    <template slot-scope="scope">
                        <el-button
                                @click="handleEdit(scope.$index, scope.row)"
                                icon="el-icon-edit"
                                type="text"
                        >编辑
                        </el-button>

                    </template>
                </el-table-column>
            </el-table>
            <div class="searchPage" v-show="show.search">
                共计 【 {{pageTotal}} 】条符合条件的结果
            </div>

            <div class="pagination" v-show="show.page">
                <el-pagination
                        :current-page="query.pageIndex"
                        :page-size="query.pageSize"
                        :total="pageTotal"
                        @current-change="handlePageChange"
                        background
                        layout="total, prev, pager, next"
                ></el-pagination>
            </div>
        </div>

        <!-- 编辑弹出框 -->
        <el-dialog :visible.sync="editVisible" title="编辑分类信息" width="50%">
            <el-form :model="form" label-width="70px" ref="form">
                <el-row :gutter="20">
                    <el-col :span="8">
                        <el-form-item label="分类名称">
                            <el-input class='wd200' v-model="form.Cname"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="分类拼音">
                            <el-input class='wd200' v-model="form.Chinese"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="分类备注">
                            <el-input class='wd200' v-model="form.Cmemo"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="8">
                        <el-form-item label="分类等级">
                            <el-select placeholder="请选择" v-model="form.Clevel">
                                <el-option :value="1" label="一级"></el-option>
                                <el-option :value="2" label="二级"></el-option>
                                <el-option :value="3" label="三级"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="是否末级">
                            <el-select placeholder="请选择" v-model="form.CnodeFlg">
                                <el-option :value="1" label="是末级"></el-option>
                                <el-option :value="0" label="非末级"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="排序编号">
                            <el-input class='wd200' v-model="form.CorderId"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="8">
                        <el-form-item label="分类类别">
                            <el-select placeholder="请选择" v-model="form.Ctype">
                                <el-option :value="0" label="机构规模"></el-option>
                                <el-option :value="1" label="业务范围"></el-option>
                                <el-option :value="2" label="业务类型"></el-option>
                                <el-option :value="3" label="客户等级"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="分类状态">
                            <el-select placeholder="请选择" v-model="form.Cstate">
                                <el-option :value="0" label="屏蔽"></el-option>
                                <el-option :value="1" label="显示"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="父级编码">
                            <el-input class='wd200' v-model="form.Cpid"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <span class="dialog-footer" slot="footer">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button @click="saveEdit" type="primary">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: 'basetable',
        data() {
            return {
                query: {
                    pageIndex: 1,
                    pageSize: 10
                },
                pageTotal: 0,
                search: {
                    keyword: ''
                },
                show: {
                    page: true,
                    search: false
                },
                tableData: [],
                editVisible: false,
                form: {},
                idx: -1,
                id: -1
            };
        },
        created() {
            this.getInMenuData();
        },
        methods: {
            //2026 分页获取目录
            async getInMenuData() {
                const { data: res } = await this.$http.post('admin/incMenu/pageMenu', {
                    query: this.query
                });
                if (res.code !== 200) {
                    return this.$message.error('系统错误，获取景点分类数据失败，请联系管理员!');
                }

                this.tableData = res.list;
                this.pageTotal = res.pageTotal;
                this.search.keyword = '';
                this.show.page = true;
                this.show.search = false;
                this.$message.success('【景点分类数据】加载成功!');
            },
            //2026 分页导航
            handlePageChange(val) {
                this.$set(this.query, 'pageIndex', val);
                this.getInMenuData();
            },
            //2026 编辑操作界面
            handleEdit(index, row) {
                this.idx = index;
                this.form = row;
                this.editVisible = true;
            },
            //2026 保存编辑
            async saveEdit() {
                this.editVisible = false;
                this.$set(this.tableData, this.idx, this.form);
                const { data: res } = await this.$http.post('/admin/incmenu/updateMenu', {
                    form: this.form
                });
                if (res.code !== 200) {
                    return this.$message.error('系统错误，修改数据失败，请联系管理员!');
                }
                this.$message.success(res.message);
            },

            //2026 触发搜索按钮
            async handleSearch() {
                const { data: res } = await this.$http.post('admin/incmenu/searchMenu', {
                    search: this.search
                });
                if (res.code !== 200) {
                    return this.$message.error('系统错误，获取景点数据失败，请联系管理员!');
                }

                this.tableData = res.list;
                this.pageTotal = res.pageTotal;
                this.show.page = false;
                this.show.search = true;
                this.$message.success('搜索成功，共有【 ' + res.pageTotal + ' 】符合条件的结果');
            },

            //2026 标签筛选
            filterTag(value, row) {
                console.log('is runing' + value);
                return row.Ctype == value;
            }
        }
    };
</script>

<style scoped>

    .searchPage {
        font-size: 14px;
        color: #606266;
        padding: 20px 0px;
    }

    .handle-box {
        margin-bottom: 20px;
    }

    .handle-select {
        width: 120px;
    }

    .handle-input {
        width: 300px;
        display: inline-block;
    }

    .table {
        width: 100%;
        font-size: 14px;
    }

    .red {
        color: #ff0000;
    }

    .mr10 {
        margin-right: 10px;
    }

    .wd200 {
        width: 200px;
    }

    .table-td-thumb {
        display: block;
        margin: auto;
        width: 40px;
        height: 40px;
    }
</style>
